import { React, useEffect, useRef, useState } from "react";
import useProjectStore, { getProjectStore } from '../store/projectStore';
import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
// Commented out JSONForms imports
// import { JsonForms } from "@jsonforms/react";
// import { materialRenderers } from "@jsonforms/material-renderers";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { DialogLogo } from "./APPF_ICONS";
import { getApiUrl, uuidv4 } from "./commons";
import { poolData } from "../UserPool";
import { focusFirstInput } from "../utils/domUtils";

export function isValidUrl (string) {
    try {
      new URL(string);

      return true;
    } catch (err) {
      return false;
    }
  }

async function createSourceEnv (prj, accT) {
    const apiURL = getApiUrl(poolData.envURL);
    const eid = Math.floor(Math.random() * (9999));

    let bContent = JSON.stringify({
        name: `${prj.name}_SE`,
        environment_external_id: `${prj.name}_${eid}`,
        description: `${prj.name} - default source`,
        project_id: prj.id
    });

    fetch(apiURL + "/mgmt/environments/source", {
        method: "POST",
        "sec-fetch-mode": "cors",
        "sec-fetch-site": "cross-site",
        "access-control-request-headers": "authorization,content-type",
        headers: {
            "Authorization": `Bearer ${accT}`,
            "Content-Type": "application/json"
        },
        body: bContent
    });
}

async function getProjects (accT) {
    const prjName = localStorage.prjName ? localStorage.prjName : "projects";
    const url = getApiUrl(poolData.envURL) + `/mgmt/${prjName}`;
    const accessToken = accT || poolData.accessToken;

    try {
        const response = await fetch(url, {
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        });

        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const json = await response.json();
       
        try {
            const store = getProjectStore();
            store.setProjectContext({
                currentProjectId: store.currentProjectId,
                currentSEnv: store.currentSEnv,
                projects: JSON.parse(JSON.stringify(json)),
                sEnv: store.sEnv,
            });
        } catch (e) { /* */ }

        for (let i = 0; i < json.length; i++) {
            let prj = json[i];
            let urlEnv = getApiUrl(poolData.envURL) + `/mgmt/environments/source/${prjName}/${prj.id}`;

            let responseEnv = await fetch(urlEnv, {
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            });
    
            const jsonEnv = await responseEnv.json();

            if (jsonEnv.length == 0){
                createSourceEnv(prj,accessToken);
            }
        }
    
        return json;
    } catch (e) {
        return {};
    }
}

export async function deleteProject(id, poolData, setProjectDivId) {
    await poolData.refreshToken();
    const apiURL = getApiUrl(poolData.envURL);

    fetch(apiURL + `/mgmt/projects/${id}`, {
        method: "DELETE",
        "access-control-request-headers": "authorization",
        headers: {
            "Authorization": `Bearer ${poolData.accessToken}`
        }
    })
        .then(response => response.text())
        .then(async () => {
            await getProjects();

            setTimeout(() => {
                setProjectDivId(uuidv4());
            }, 420);
        })
        .catch(error => console.log('error', error));

    return {}
}

const providerList = ["newAppComponent"];

function NewApplicationComponent(props) {
    const currentProjectId = useProjectStore(s => s.currentProjectId);
    const mFields = ["name", "description", "repositoryUrl", "token", "repositoryType", "projectId"];

    const NEW_APP_COMPONENT = gql`mutation createOrUpdateApplicationComponent(
       ${mFields.map((f,i)=>`
        $${f}: String${i>0?"!":""}`).join(",")}
    ) {
        createOrUpdateApplicationComponent(
            component:{
                ${mFields.map((f)=>`
                    ${f} : $${f}`).join(",")}
            }
        )
        {
            id
            name
        }
    }`;
    const [newAppComponent] = useMutation(NEW_APP_COMPONENT);
    
    const LINK_TO_APPCOMPONENT = gql`mutation LinkAppToComponent($appId: String!, $componentId: String!, ) {\n linkAppToComponent(appId: $appId,componentId:$componentId )\n}`;
    const [linkToAppComponent ] = useMutation(LINK_TO_APPCOMPONENT);   

    const [formData, setFormData] = useState(localStorage.editData?JSON.parse(localStorage.editData): {});
    /* eslint-disable */
    const [errors, setErrors] = useState([]);
    const [currentProvider] = useState(providerList[0]);

    useEffect(() => {
        if (props.open) {
            setTimeout(() => {
                setFormData(localStorage.editData?JSON.parse(localStorage.editData): {repositoryType: "GitHub"});

                try {
                    delete localStorage.editData;
                } catch (e) { /* */ }

                focusFirstInput('.newTargetProject');
            }, 100);
        }
    }, [props.open]);

    const handleClose = () => {
        delete window.linkToApp;
        
        setErrorText("");
        props.setOpen(false);
    };

    const [errorText, setErrorText] = useState("");
    const formControlRef = useRef();
    // const jsonForms = useRef(); // Commented out jsonForms ref since JsonForms removed
    const allFields = [ "name",
                        "description",
                        "repositoryUrl",
                        "token",
                        "repositoryType" ];

    const fields = 
        window.linkToApp ? {
            newAppComponent: [
                "repositoryUrl",
                "token",
                "repositoryType"
            ]
        }
        :
        {
            newAppComponent: [
            ...allFields
            ]
        };

    const uischema = {
        "type": "VerticalLayout",
        "elements": [{
            "type": "HorizontalLayout",
            "elements": [{
                "type": "VerticalLayout",
                "elements": fields[currentProvider]
                    .map(field => {
                        if(field == "token"){
                            return ({
                                "type": "Control",
                                "scope": `#/properties/${field}`,
                                "options": {
                                    "format": "password"
                                }
                            })
                        }else if(field == "repositoryType"){
                            return ({
                                "type": "Control",
                                "scope": `#/properties/${field}`,
                                "options": {
                                    format: "radio"
                                }})
                            }

                        return ({
                                "type": "Control",
                                "scope": `#/properties/${field}` 
                            })
                    })
                }]
            }
        ]
    };

    const schema = {
        "type": "object",
        "properties": {
            ...fields[currentProvider].map(field => (
                 
                 field=="token" ?
                 {
                    [field]: {
                        "type": "string",
                        "minLength": 8,
                        "maxLength": 250
                    }
                 }
                 :
                field.startsWith("is_") ?
                    {
                        [field]: {
                            "type": "boolean"
                        }
                    }
                    :
                    field == "repositoryType" ?
                    {
                        [field]:{
                            "type": "string",
                            "enum": [
                              "GitHub",
                              "GitLab"
                            ]
                        }
                    }
                    :
                    {
                        [field]: {
                            "type": "string",
                            "minLength": 4,
                            "maxLength": 250
                        }
                    }
            )).reduce((acc, curr) => ({ ...acc, ...curr }), {})
        }
    };

    return (
        <Dialog
            className="newTargetProject"
            style={{
                margin:"0px",
                padding:"0px",
                background: "0,0,0, 0.42)",
                height: "100%",
                backdropFilter: "blur(4.2px)",
                alignItems: "right"
            }}
            open={props.open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    component: "form",
                    sx: {
                        padding:"4px",
                        backgroundColor: "rgba(0,0,0,1)",
                        background: "var(--allAccentBackground)"
                    }
                }
            }}
        >
            <DialogLogo />

            <DialogTitle
                style={{
                    color: "var(--text-color-add-form)",
                    marginTop: "22px",
                    marginBottom: "0px",
                    marginLeft: 0,
                    paddingBottom:0,
                    paddingLeft:"5px"
                }}
            >
                <div
                    style={{
                        display: "inline-block",
                        width: "100%",
                        textAlign: "center"
                    }}
                >
                    <div
                        style={{
                            display: "inline-block",
                            width: "calc(100% - 100px)",
                            textAlign: "left",
                            marginTop: 0,
                            marginBottom: 0,
                            marginLeft: 0
                        }}
                    > {typeof formData.id !== "undefined"?"EDIT APPLICATION COMPONENT":"NEW APPLICATION COMPONENT"}
                    </div>
                </div>
            </DialogTitle>

            <DialogContent
                ref={formControlRef}
                style={{
                    margin: "20px",
                    marginTop: 0,
                    paddingTop:0,
                    marginBottom: 0,
                    marginLeft: 32,
                    height: "100%",
                    minHeight: "200px",
                    width: "calc(100% - 112px)",
                    scrollbarColor: "var(--scan-main-input-chip-bg-color) rgba(0,0,0,0)",
                    scrollbarWidth: "thin",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center"
                }}
            >
                <div
                    className="newTargetProject__content"
                    style={{
                        height: "50%",
                        width: "100%",
                        maxWidth: "720px",
                        margin: "0",
                        marginTop:"0px"
                    }}
                >
                    <div
                        className="newTargetProject__content"
                        style={{
                            height: "100%",
                            width: "100%"
                        }}
                    >
                        {/* JsonForms removed */}
                        {/* <JsonForms
                            ref={jsonForms}
                            schema={schema}
                            uischema={uischema}
                            renderers={materialRenderers}
                            data={formData}
                            validationMode={"ValidateAndShow"}
                            onChange={({ errors, data }) => {
                                setErrors(errors);
                                setFormData(data);
                            }}
                        /> */}
                        <div style={{ color: 'var(--text-color-add-form)', fontSize: '14px' }}>
                            JSON Forms temporarily disabled.
                        </div>
                    </div>
                </div>

                {errorText && <div
                    style={{
                        marginTop: 42,
                        textAlign: "left",
                        marginLeft: 4,
                        maxWidth: 470,
                        paddingTop: "10px",
                        paddingBottom: "10px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                        borderRadius: "8px",
                        background: "#41120E",
                        color: "var(--text-color-add-form)"
                    }}
                >
                    {errorText}
                </div>}
            </DialogContent>

            <DialogActions
                style={{
                    margin: 20,
                    marginTop: "5px",
                    marginLeft: 25,
                    position: "relative",
                    justifyContent: "center"
                }}
            >
                <Button
                    id="savecred"
                    className="add-credential__save"
                    style={{
                        opacity: (errors.length > 0) ? 0.35 : 1
                    }}
                    onClick={() => {
                        try {
                            allFields.forEach(f => {
                                if(formData[f] == undefined) {
                                    let newVal = document.querySelector(`id="#/properties/${f}-input"]`).value;

                                    if( newVal !== undefined && newVal !== "") {
                                        formData[f] = newVal;
                                    }

                                    setErrorText("Field "+f+" is required");

                                    throw new Error("");
                                }
                            })
                        } catch (e){ /* */ }

                        if (errors.length > 0) {
                            console.log("errors", errors);
                        } else {
                            try {
                                if (formData.repositoryUrl != null && typeof formData.repositoryUrl !== "undefined" && !isValidUrl(formData.repositoryUrl)) {
                                    setErrorText("Please enter a valid URL.");

                                    return;
                                }
                            } catch (e) { /* */ }

                            setErrorText("");

                            newAppComponent({
                                variables: {
                                    ...formData,
                                    ...( window.linkToApp ? {
                                        description : `${window.linkToApp.description}`,
                                        name : `${window.linkToApp.name} (SOURCES)`
                                    } : {}),
                                    projectId: currentProjectId
                                }
                            }).then(res => {
                                try {
                                    if (res?.data?.createOrUpdateApplicationComponent) {
                                        let findComp = res.data.createOrUpdateApplicationComponent;

                                        if (window.linkToApp && findComp) {
                                            linkToAppComponent({
                                                variables: {
                                                    appId:window.linkToApp.id,
                                                    componentId: findComp.id
                                                }
                                            }).then(()=>{
                                                delete window.linkToApp;
                                            })

                                            props.setProjectDivId()

                                            setFormData({})
                                            handleClose();    
                                        } else {
                                            props.setProjectDivId();

                                            setFormData({});
                                            handleClose();
                                        }

                                    }
                                } catch (e) { /* */ }
                            }, ({...allParams}) => {
                                setErrorText(allParams.message);

                                console.log("allParams", allParams);
                            });
                        }
                    }}
                >
                    Save
                </Button>

                <Button
                    className="add-credential__cancel"
                    onClick={() => {
                        setErrorText("");
                        handleClose();
                    }}
                    style={{
                        marginLeft: 12
                    }}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default NewApplicationComponent;
